import React from 'react';
import {NavItem} from 'reactstrap';
import {NavLink, useLocation} from 'react-router-dom';

const SidebarNavItem = ({ link, icon, menuText, onClick, badgeCount = 0, statusNode = null }) => {
    const location = useLocation();

    const checkActive = () => {
        if (link === '/' || link === '/organizations/own/content') {
            return location.pathname === link;
        }

        return location.pathname.includes(link);
    };

    return (
        <NavItem active={checkActive()}>
            <NavLink to={link} onClick={onClick} className="nav-link d-flex align-items-center">
                <span className={`fas fa-fw fa-sm me-2 ${icon}`} />
                <span className="flex-grow-1 text-truncate text-start">{menuText}</span>
                {badgeCount > 0 && (
                    <span className="badge bg-danger ms-auto">
                        {badgeCount > 99 ? '99+' : badgeCount}
                    </span>
                )}
                {statusNode}
            </NavLink>
        </NavItem>
    );
};

export default SidebarNavItem;
